/* LP Kit — comportamiento de las secciones lp-*. Sin dependencias. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(el) {
    if (el.dataset.lpReady) return; el.dataset.lpReady = '1';
    var out = el.querySelector('[data-lp-timer]');
    var mode = el.dataset.mode || 'end_of_day';
    var hours = parseFloat(el.dataset.hours || '12');
    var end;
    if (mode === 'rolling') {
      var key = 'lpCountdownEnd';
      try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600000;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }
    } else {
      var off = parseFloat(el.dataset.tz || '-6'); var g = new Date(Date.now() + off * 3600000); g.setUTCHours(23, 59, 59, 999); end = g.getTime() - off * 3600000;
    }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
      out.textContent = pad(h) + 'h : ' + pad(m) + 'm : ' + pad(s) + 's';
      if (diff === 0 && mode === 'rolling') { end = Date.now() + hours * 3600000; }
    }
    tick(); setInterval(tick, 1000);
  }

  function initMini(el) {
    if (el.dataset.lpReady) return; el.dataset.lpReady = '1';
    var items = el.querySelectorAll('.lp-mini__item');
    var dots = el.querySelectorAll('.lp-mini__dot');
    if (items.length < 2) return;
    var i = 0, timer;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function restart() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, 4500); }
    var prev = el.querySelector('[data-lp-prev]'), next = el.querySelector('[data-lp-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(i + 1); restart(); });
    show(0); restart();
  }

  function initScroller(el) {
    if (el.dataset.lpReady) return; el.dataset.lpReady = '1';
    var track = el.querySelector('.lp-scroller');
    var dotsWrap = el.querySelector('.lp-dots');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (dotsWrap) {
      dotsWrap.innerHTML = slides.map(function () { return '<span></span>'; }).join('');
    }
    var dots = dotsWrap ? dotsWrap.children : [];
    function current() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      slides.forEach(function (s, k) { var m = s.offsetLeft + s.offsetWidth / 2; var dd = Math.abs(m - c); if (dd < bestD) { bestD = dd; best = k; } });
      return best;
    }
    function paint() { var k = current(); for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === k); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    paint();
    var auto = parseInt(el.dataset.autoplay || '0', 10);
    if (auto > 0 && slides.length > 1) {
      var paused = false;
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        var r = track.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var k = (current() + 1) % slides.length;
        var s = slides[k];
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      }, auto * 1000);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lp-countdown]').forEach(initCountdown);
    (root || document).querySelectorAll('[data-lp-mini]').forEach(initMini);
    (root || document).querySelectorAll('[data-lp-slider]').forEach(initScroller);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
